import React from "react";
import { useRules } from "./provider/RulesContext";
import Projects from "./components/Projects";
import RulesData from "./components/RulesData";

const DisplayRules = () => {
  const { view } = useRules();
  return (
    <div className="h-full w-full ">
      {view === "projects" ? <Projects /> : <RulesData />}
    </div>
  );
};

export default DisplayRules;
